module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-180x180-83442f5eb5c0715162d9ab7e5815eb79.png";